import React, { useEffect, useState, useContext } from "react";
import moment from "moment";
import { CurrencyWithAmount } from "../../../../../helpers/utils";
import { discountContentByCondition } from "../../../../../helpers/common";


const OfferBox = ({ query, groupDiscounts, ticketDetails, isWidget }) => {
	// Get the current date and time
	const currentDateTime = new Date();

	// Ensure ticketDetails is an array and filter out sold out tickets or expire
	const liveTickets = Array.isArray(ticketDetails)
        ? ticketDetails.filter(ticket => {
              const ticketEndTime = moment.utc(ticket.end_timestamp).local(); // Convert to local time
              return !ticket.sold_out && ticketEndTime.isAfter(currentDateTime);
          })
        : [];

	// Filter the groupDiscounts based on whether they have any applicable live tickets
	const validGroupDiscounts = groupDiscounts.filter(groupDiscount =>
		liveTickets.some(ticket => groupDiscount.attached_ticket_ids.includes(ticket.ticket_id))
	);

	return (
		<div className="offer-box mt-2">
			<div className="accordion" id="accordionExample">
				<div className="accordion-item offer-box-accordian-item">
					<h2 className="accordion-header" id="headingOne">
						<button className="accordion-button offer-box-accordian-btn" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
							<div className="me-2" style={{ marginBottom: "2px" }}>
								<DiscountIcon color={query.btnBg ? `#${query.btnBg}` : "#fb5850"} />
							</div> Offers available for you
						</button>
					</h2>
					<div id="collapseOne" className="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
						<div className="accordion-body pt-0">
							{validGroupDiscounts.map(groupDiscount => (
								<div key={groupDiscount.coupon_id} className="discount-container px-3 py-2 mb-2">
									<div className="discount-amount mb-1">
										Discount of {groupDiscount.coupon_type === 2 ? `${groupDiscount.discount}%` : "Flat "}
										{groupDiscount.coupon_type === 1 && <CurrencyWithAmount currencyName={groupDiscount.currency_name} number={groupDiscount.discount} />}
									</div>
									<div className="discount-description mb-1">
										{discountContentByCondition(groupDiscount)}
									</div>
									<div className="discount-applicable-tickets">
										(Applicable Tickets: {liveTickets
											.filter(ticket => groupDiscount.attached_ticket_ids.includes(ticket.ticket_id))
											.map((ticket, i, arr) => (
												<span key={ticket.ticket_id}>
													{ticket.ticket_name}{i < arr.length - 1 ? ', ' : ''}
												</span>
											))})
									</div>
								</div>

							))}
						</div>
					</div>
				</div>
			</div>
			<style jsx>{`

                .discount-container {
                    border-radius: 5px;
                    background-color: #fff;
                }
                .offer-box-accordian-btn {
                                    background: ${query.secondaryBg
					? `#${query.secondaryBg}`
					: isWidget
						? "#F7F7F7"
						: "#EFE9ED"
				} !important;
                    border: none !important;
                    box-shadow: none !important;
                    font-weight: 400;
                }

                .offer-box-accordian-btn:focus {
                    box-shadow: none !important;
                }

                .offer-box-accordian-item {
                    background: ${query.secondaryBg
					? `#${query.secondaryBg}`
					: isWidget
						? "#F7F7F7"
						: "#EFE9ED"
				};
                    border: 1px solid ${query.btnBg ? `#${query.btnBg}` : "#fb5850"
				};
                    border-radius: ${query?.borderRadius || 10}px;
                }
                .discount-amount {
                    color: ${query.btnBg ? `#${query.btnBg}` : "#fb5850"};
                    font-weight: 400;
                }
                .discount-description {
                    font-size: 14px;
                    font-weight: 400;
                    color: #212529
                }
                .discount-applicable-tickets {
                    font-size: 14px;
                    font-weight: 400;
                    opacity: 0.7;
                    color: #212529
                }
				.accordion-button{
					border-radius: 10px !important
					}
                `}</style>
		</div>
	);
};

export default OfferBox;


const DiscountIcon = ({ color }) => (
	<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M16.8843 9L17.879 7.2807C17.9986 7.07388 18.0311 6.828 17.9695 6.59718C17.9078 6.36636 17.757 6.1695 17.5502 6.04986L15.8291 5.05505V3.07267C15.8291 
        2.83369 15.7342 2.60449 15.5653 2.43551C15.3962 2.26652 15.1671 2.17159 14.9281 2.17159H12.9467L11.9528 0.451418C11.8328 0.244994 11.6363 0.094143 11.4059 
        0.0315131C11.2916 0.000530201 11.1723 -0.00745889 11.0549 0.00800893C10.9375 0.0234767 10.8244 0.062094 10.722 0.121621L9.00096 
        1.11641L7.27998 0.12072C7.07304 0.00123465 6.8271 -0.0311454 6.59622 0.030703C6.3654 0.0925512 6.1686 0.243562 6.04914 0.450517L5.05436 2.17159H3.07295C2.83397 
        2.17159 2.60479 2.26652 2.4358 2.43551C2.26682 2.60449 2.17189 2.83369 2.17189 3.07267V5.05415L0.450878 6.04896C0.348188 6.108 0.25818 6.18678 0.186027 
        6.28074C0.113875 6.3747 0.0609984 6.48204 0.0304372 6.59646C-0.000123974 6.71094 -0.00776802 6.83034 0.0079443 6.94776C0.0236566 7.06518 0.0624156 7.17834 0.121994 
        7.2807L1.11676 9L0.121994 10.7192C0.0030449 10.9263 -0.029228 11.172 0.0322117 11.4027C0.0936516 11.6335 0.24382 11.8306 0.449978 11.951L2.17099 12.9458V14.9273C2.17099 
        15.1663 2.26592 15.3955 2.4349 15.5645C2.60389 15.7334 2.83307 15.8284 3.07204 15.8284H5.05436L6.04914 17.5495C6.12888 17.6858 6.24282 17.7991 6.37962 17.8781C6.51642 
        17.9571 6.67146 17.9991 6.82944 18C6.98622 18 7.1421 17.9585 7.28088 17.8784L9.00006 16.8836L10.7211 17.8784C10.928 17.9977 11.1737 18.0301 11.4045 17.9684C11.6353 
        17.9068 11.8321 17.7561 11.9519 17.5495L12.9458 15.8284H14.9272C15.1662 15.8284 15.3953 15.7334 15.5644 15.5645C15.7333 15.3955 15.8282 15.1663 15.8282 14.9273V12.9458L17.5493 
        11.951C17.6518 11.8918 17.7416 11.8129 17.8136 11.719C17.8856 11.6249 17.9384 11.5177 17.969 11.4033C17.9995 11.2889 18.0073 11.1696 17.9917 11.0522C17.9761 10.9349 
        17.9375 10.8217 17.8781 10.7192L16.8843 9ZM6.74742 4.48556C7.10604 4.48568 7.44984 4.62825 7.70334 4.88189C7.95684 5.13554 8.09916 5.47949 8.09904 5.83809C8.09892 
        6.19668 7.95636 6.54054 7.70268 6.79404C7.44906 7.04748 7.10514 7.18986 6.74652 7.18974C6.38796 7.18962 6.0441 7.047 5.79064 6.79338C5.53717 6.53976 5.39484 6.19578 
        5.39496 5.83719C5.39508 5.47859 5.53764 5.13474 5.79128 4.88126C6.04494 4.62778 6.38886 4.48544 6.74742 4.48556ZM7.01778 13.136L5.57607 12.0556L10.9824 
        4.8469L12.4241 5.9273L7.01778 13.136ZM11.2527 13.4964C11.0752 13.4963 10.8994 13.4613 10.7353 13.3933C10.5713 13.3253 10.4223 13.2256 10.2968 13.1C10.1713 
        12.9745 10.0718 12.8254 10.0039 12.6613C9.936 12.4973 9.90108 12.3214 9.90114 12.1439C9.9012 11.9663 9.93624 11.7905 10.0042 11.6265C10.0722 11.4625 10.1719 
        11.3134 10.2974 11.188C10.423 11.0624 10.5721 10.9629 10.7362 10.895C10.9003 10.8271 11.0761 10.7922 11.2536 10.7923C11.6122 10.7924 11.956 10.9349 12.2095 
        11.1886C12.463 11.4422 12.6053 11.7862 12.6052 12.1448C12.6051 12.5033 12.4625 12.8472 12.2089 13.1007C11.9552 13.3542 11.6113 13.4965 11.2527 13.4964Z" fill={color ? color : "#fb5850"} />
	</svg>
)